import React, { useState } from 'react';

import { CircularButton, Typography } from '@hpstellar/core';

import './game-card.less';

export default function GameCard({ title, imgUrl, fps, onToggle, selected, disable }) {
    const [hover, setHover] = useState(false);

    const toggleSelect = () => {
        if (disable) return;
        onToggle();
    };

    return (
        <div
            className={`gameCardContainer${selected ? ' selected' : ''}${imgUrl ? '' : ' noImg'}${
                disable && !selected ? ' disable' : ''
            }`}
            onClick={toggleSelect}
        >
            <div className="hoverLayer" onMouseOver={() => setHover(true)} onMouseOut={() => setHover(false)} />
            <div className="imgContainer">
                {!hover && (imgUrl ? <img src={imgUrl} /> : <div className="fpsImgGradient" />)}
                {hover && !selected && (
                    <div className="imgButton">
                        <CircularButton icon="plus" useTransparentBg />
                        <Typography variant="boldXS">ADD GAME</Typography>
                    </div>
                )}
                {hover && selected && (
                    <div className="imgButton">
                        <CircularButton icon="cross" useTransparentBg />
                        <Typography variant="boldXS">REMOVE</Typography>
                    </div>
                )}
            </div>
            <div className="desc">
                <Typography variant="boldS">{title}</Typography>
                <Typography variant="bodyXS">{fps}</Typography>
            </div>
        </div>
    );
}
